
import React from 'react';
import { FlowRender } from "../flow-render";
import {InvestmentKnowledgeRadioButton} from "./investment-knowledge-radio-button";
import { Name } from "../prm/name";
import {RADIO_SINGLE_RANDOM_VALUE, RadioButton} from "../prm/radio-button";
import {Text} from "../prm/text";

const role_0_investment_knowledge = new InvestmentKnowledgeRadioButton(
  new Name("role_0_investment_knowledge"));

const risk_exposure = new RadioButton(
  new Name("risk_exposure"), [
    new Name("low", "Low"),
    new Name("moderate", "Moderate"),
    new Name("spec", "Speculative"),
    new Name("high", "High"),
  ], [], RADIO_SINGLE_RANDOM_VALUE);

const investment_objectives = new RadioButton(
  new Name("investment_objectives"), [
    new Name("income", "Income"),
    new Name("longTermGrowth", "Long-Term Growth"),
    new Name("shortTermGrowth", "Short-Term Growth"),
  ], [], RADIO_SINGLE_RANDOM_VALUE);

const time_horizon = new Text(
  new Name("time_horizon"), null, {
    path: "random.num",
    arg0: 2,
    arg1: 5
  });

const liquidity_needs = new RadioButton(
  new Name("liquidity_needs"), [
    new Name("high", "High"),
    new Name("medium", "Medium"),
    new Name("low", "Low"),
  ], [], RADIO_SINGLE_RANDOM_VALUE);

class InvestmentKnowledge extends FlowRender {
  constructor(index) {
    super(index, [
      role_0_investment_knowledge,
      risk_exposure,
      investment_objectives,
      time_horizon,
      liquidity_needs,
    ]);
  }

  canNavigateNext(component) {
    const highlight_rects = [];

    this.prmList.forEach(prm => {
      prm.isFilledElseHighlight(component.state, highlight_rects);
    });

    if (highlight_rects.length > 0) {
      component.setState({ highlight_rects });
      return null;
    }

    return component.getRootUrl() + "/bd_affiliation";
  }

  dumpButtons = (component, prm) => {

    const render_button = (index) => {
      const label_style = {
        marginLeft: "1.5rem",
      }
      const checkbox_style = {
        transform: "scale(1.2) translateY(0.2rem)",
      }

      return (
        <div style={{ flex: "1"}} key={index}>
          { prm.renderCheckbox(index, component, checkbox_style) }
          { prm.renderLabel(index, component.state, label_style) }
        </div>
      )
    }

    const container_style = {
      display: "flex",
      width: "100%",
    }
    return (
      <div style={container_style}>
        { prm.buttonList.map((button, index) => render_button(index)) }
      </div>
    )
  }

  dumpObjectives = component => {
    const text = "We understand that you are purchasing a CD for your own account; "
      + "however, we are still required to ask these questions.";
    const liquid_disclaimer = "CDs are designed to be held to maturity and liquidity "
      + "may be limited in case you wish to sell your CD";
    const title_style = {
      fontWeight: "bold",
    }
    const input_style = {
      textAlign: "center"
    }
    const show_liquid_disclaimer =
      liquidity_needs.isItemClicked(0, component.state)
      || liquidity_needs.isItemClicked(1, component.state);
    const liquid_style = {
      visibility: show_liquid_disclaimer ? "visible": "hidden",
      marginTop: "0.5rem",
    }
    return (
      <div>
        <div>{text}</div>
        <div style={{height: "2rem"}}/>
        <div style={title_style}>
          I would describe my investment knowledge and experience as:
        </div>
        <div style={{height: "0.5rem"}}/>
        { this.dumpButtons(component, role_0_investment_knowledge) }
        <div style={{height: "1rem"}}/>
        <div style={title_style}>My comfort level with portfolio risk:</div>
        <div style={{height: "0.5rem"}}/>
        { this.dumpButtons(component, risk_exposure)}
        <div style={{height: "1rem"}}/>
        <div style={title_style}>My account investment objectives:</div>
        <div style={{height: "0.5rem"}}/>
        { this.dumpButtons(component, investment_objectives) }
        <div style={{height: "1rem"}}/>
        <div style={title_style}>My time horizon in years:</div>
        { time_horizon.renderInput(component, input_style)}
        <div style={{height: "1rem"}}/>
        <div style={title_style}>My liquidity needs:</div>
        { this.dumpButtons(component, liquidity_needs) }
        <div style={liquid_style}>
          { liquid_disclaimer }
        </div>
      </div>
    )
  }
  render = (component) => {
    const container_style = {
      width: "75%",
      margin: "auto",
    }
    return (
      <div>
        { this.renderHighlightRects(component) }
        { this.renderTitle(component, "Investment Knowledge", "75%")}
        { this.renderProgress(component, "75%") }
        <section className={"section"}>
          <div style={container_style}>
            { this.dumpObjectives(component) }
          </div>
        </section>
        { this.renderNextButtonRow(component, true) }
      </div>
    )
  }
}

export { InvestmentKnowledge };
